import { useCallback, useEffect, useState } from "react";

async function jsonFetch(path, options = {}) {
  const res = await fetch(path, { credentials: "include", ...options });
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    throw new Error((data && data.error) || `Request failed (${res.status})`);
  }
  return data;
}

export default function useEditAuth() {
  const [checked, setChecked] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    jsonFetch("/api/auth/me")
      .then((data) => {
        if (!cancelled) setAuthenticated(Boolean(data && data.authenticated));
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setChecked(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const login = useCallback(async (password) => {
    await jsonFetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });
    setAuthenticated(true);
  }, []);

  const logout = useCallback(async () => {
    try {
      await jsonFetch("/api/auth/logout", { method: "POST" });
    } finally {
      setAuthenticated(false);
    }
  }, []);

  return { checked, authenticated, login, logout };
}
